"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var dayjs_1 = tslib_1.__importDefault(require("dayjs"));
var customParseFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/customParseFormat"));
// required for the custom save formats in the date, time and date-time pickers
dayjs_1.default.extend(customParseFormat_1.default);
exports.createOnChangeHandler = function (path, handleChange, saveFormat) { return function (time) {
    if (!time) {
        handleChange(path, undefined);
        return;
    }
    var result = dayjs_1.default(time).format(saveFormat);
    handleChange(path, result === 'Invalid Date' ? undefined : result);
}; };
exports.getData = function (data, saveFormat) {
    if (!data) {
        return null;
    }
    var dayjsData = dayjs_1.default(data, saveFormat);
    if (dayjsData.toString() === 'Invalid Date') {
        return null;
    }
    return dayjsData;
};
//# sourceMappingURL=datejs.js.map